import React, { useState, useEffect } from "react";
import Widget from "components/Widget";
import PropTypes from 'prop-types';
import SellerProductCard from 'components/viewSellerProductCard';
import { Button, FormGroup, Label, Input } from 'reactstrap';
import CircularProgress from '@mui/material/CircularProgress';
import { Row, Col } from "reactstrap";
import { TextField } from "@mui/material";
import './index.css'
import { getAutoFill, togglePopup } from 'actions/buyer';
import { isBrowser } from "react-device-detect";
import { getProductsBySeller, getCategories } from 'actions/buyer';
import { connect } from 'react-redux';
import { useParams } from "react-router-dom";
import axios from 'constants/axios';

function TabContainer({ children, dir }) {
  return (
    <div dir={dir} style={{ padding: 8 * 3 }}>
      {children}
    </div>
  );
}
TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
  dir: PropTypes.string.isRequired,
};

const About = (props) => {
  const params = useParams()
  const [value, setValue] = useState('')
  const [value1, setValue1] = useState('')
  const [perPage, setPerPage] = useState(12)
  const [hidden, setHidden] = useState(false)
  const [searchText, setSearchText] = useState('')
  const [companies, setCompanies] = useState([])
  const [mediType, setMediType] = useState('')
  const [medicineTypes, setMedicineTypes] = useState([])

  // Category, company, medicine type and the search box all narrow the same listing, so every fetch
  // carries all of them - sending only the filter that just changed would drop the other ones.
  const fetchProducts = (overrides = {}) => {
    const filters = { category: value, company: value1, mediType, key: searchText, perPage: 12, ...overrides }
    props.getProductsBySeller({
      seller_id: params.id,
      category_id: filters.category !== '' ? [filters.category] : [],
      company_id: filters.company !== '' ? filters.company : "",
      medi_type: filters.mediType,
      page: 1,
      key: filters.key,
      perPage: filters.perPage
    })
  }

  const handleChange = (event) => {
    setValue(event.target.value)
    setPerPage(12)
    fetchProducts({ category: event.target.value })
  };
  const handleChangeCompany = (event) => {
    setValue1(event.target.value)
    setPerPage(12)
    fetchProducts({ company: event.target.value })
  };
  const handleChangeMediType = (event) => {
    setMediType(event.target.value)
    setPerPage(12)
    fetchProducts({ mediType: event.target.value })
  };
  const seeMoreProducts = () => {
    fetchProducts({ perPage: Number(perPage) + 12 })
    setHidden(true)
    setPerPage(Number(perPage) + 12)
    setTimeout(() => {
      setHidden(false)
    }, 2000)
  }

  const handleSigninOnEnter = (e) => {
    if (e.key === "Enter") {
      fetchProducts({ perPage: perPage })
    }
  }
  const getCompanies = async (seller_id) => {
      try {
        const result = await axios.post('inventory/get_companies', seller_id, {
          headers: {
            'Content-Type': 'application/json',
            'token': localStorage.getItem('buyer_token')
          }
        })
        console.log(result, "result")
        setCompanies(result.data.detail)
      } catch (error) {
        console.log(error, "error from getCompanies")
      }
  }
  /*
  Fills the Medicine Type filter. Reads the PUBLIC list (`_id` + name only), with no token.

  This page renders for a guest - the seller's products, their categories and their companies all
  load without a login - but this one filter used to call `medicine/listMediCategory`, which is behind
  `authenticateUser`. A visitor with no `buyer_token` got a rejected call, an empty `medicineTypes`,
  and a dropdown with nothing in it but its placeholder, while every other control on the row worked.

  `medicine/publicMediCategory` carries the two fields the dropdown uses and none of the commission /
  minimum-order configuration the authenticated list returns, so nothing is exposed by asking for it
  without a token. Same `{ data: [...] }` shape, so the mapping below is unchanged.
  */
  const getMedicineTypes = async () => {
    try {
      const result = await axios.get('medicine/publicMediCategory')
      setMedicineTypes(result.data && result.data.data ? result.data.data : [])
    } catch (error) {
      console.log(error, "error from getMedicineTypes")
    }
  }
  useEffect(() => {
    props.getCategories({ seller_id: params._id })
    getCompanies({ seller_id: params._id })
    getMedicineTypes()
  }, [])

  const { dataFromParent, categoriesFromParent, product } = props;

  // The search box and the three filters share one line, so each one's width has to absorb its own
  // margin - percentages alone would overflow the row by the 75px of gutters between them. Desktop
  // spends 39% on the search box and 20% on each filter (99% total, the last 1% is slack so a
  // rounded-up pixel can't wrap the last dropdown). On mobile the search box keeps its own line and
  // the three filters split the next one.
  const searchStyle = { margin: '15px', float: 'left', width: isBrowser ? 'calc(39% - 30px)' : 'calc(100% - 30px)' }
  const filterStyle = { marginRight: '15px', float: 'right', width: isBrowser ? 'calc(20% - 15px)' : 'calc(33% - 15px)' }

  return (
    <Widget styleName="jr-card-full jr-card-tabs-right jr-card-profile">
      <div position="static" color="default" >
        <Row style={searchStyle}>
          <Col>
            <div className="search-bar right-side-icon bg-transparent">
              <div className="form-group search-container d-flex">
                <TextField
                  style={{ border: '2px solid #072791', borderRadius: "0px" }}
                  name="searchTextBoxField"
                  InputProps={{ sx: { height: 40 } }}
                  type="search"
                  className="inputRounded"
                  onKeyDown={handleSigninOnEnter}
                  onChange={(e) => setSearchText(e.target.value)}
                  fullWidth
                  size="small"
                  variant='outlined'
                  placeholder="Search Medicine"
                />
                <div style={{ textAlign: "right", color: "#072791", marginLeft: "-46px", zIndex: "100", marginTop: "8px" }}>
                  <i className="zmdi zmdi-search  zmdi-hc-2x"></i>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Col>
          <FormGroup style={filterStyle} >
            <Label for="exampleSelect"></Label>
            <Input
              type="select"
              name="select"
              onChange={handleChangeCompany}
              value={value1}
            >
              <option value={''}>Companies</option>
              {
                companies && companies.map((val, i) =>
                  <option value={val._id} key={i}>{val.name}</option>
                )
              }
            </Input>
          </FormGroup>
        </Col>
        <Col>
          <FormGroup style={filterStyle} >
            <Label for="exampleSelect"></Label>
            <Input
              type="select"
              name="select"
              onChange={handleChange}
              value={value}
            >
              <option value={''}>Categories</option>
              {
                categoriesFromParent && categoriesFromParent.detail && categoriesFromParent.detail.map((val, i) =>
                  <option value={val._id} key={i}>{val.name}</option>
                )
              }
            </Input>
          </FormGroup>
        </Col>
        <Col>
          <FormGroup style={filterStyle} >
            <Label for="exampleSelect"></Label>
            <Input
              type="select"
              name="select"
              onChange={handleChangeMediType}
              value={mediType}
            >
              <option value={''}>Medicine Type</option>
              {
                /* 'Others' is shown as 'PCD' - the name buyers know this type by, and the one every
                   product card on this very page already prints on its badge. The option's VALUE stays
                   the stored name, because that is what the listing is filtered by. */
                medicineTypes && medicineTypes.map((val, i) =>
                  <option value={val.name} key={i}>{val.name === 'Others' ? 'PCD' : val.name}</option>
                )
              }
            </Input>
          </FormGroup>
        </Col>
      </div>
      <div className="jr-tabs-classic">
        <div className="jr-tabs-content jr-task-list">
          <TabContainer>
            <div className="row">
              {
                dataFromParent && dataFromParent.products[0] && dataFromParent.products[0].data ?
                  null
                  :
                  <div className="loader-view" style={{ margin: 'auto', marginBottom: '10px' }}>
                    <CircularProgress />
                  </div>
              }
              {dataFromParent && dataFromParent.products[0] && dataFromParent.products[0].data && dataFromParent.products[0].data.length > 0 ?
                dataFromParent && dataFromParent.products[0] && dataFromParent.products[0].data.map((value, index) =>
                  <React.Fragment>
                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                      <SellerProductCard styleName="pb-4" headerStyle="bg-gradient-primary" product={product} dataFromParentTwo={dataFromParent} value={value} togglePopup={props.togglePopup} />
                    </div>
                  </React.Fragment>
                )
                :
                dataFromParent && dataFromParent.products[0] && dataFromParent.products[0].data < 1 ?
                  <div style={{ margin: 'auto', width: '50%', textAlign: ' center', fontSize: '25px' }}>
                    <span className="text-danger" >
                      <i class="zmdi zmdi-alert-circle animated wobble zmdi-hc-5x" ></i>
                    </span>
                    <h1>Not Available !</h1>
                  </div>
                  :
                  null
              }
            </div>
            {!hidden ?
              <div style={{ textAlign: "center" }}>
                {(dataFromParent && dataFromParent.products[0] && dataFromParent.products[0].metadata[0] && dataFromParent.products[0].metadata[0].total > perPage) ?
                  <Button color="primary" className="jr-btn jr-btn-lg btnPrimary" onClick={seeMoreProducts}>
                    See More
                  </Button>
                  : ''
                }
              </div>
              :
              <div className="loader-view">
                <CircularProgress />
              </div>
            }
          </TabContainer>
        </div>
      </div>
    </Widget>
  );
}

const mapStateToProps = ({ buyer }) => {
  const { productsByCompany, categories, searchOptions } = buyer;
  return { productsByCompany, categories, searchOptions }
};

export default connect(mapStateToProps, { getAutoFill, getProductsBySeller, getCategories, togglePopup })(About)